export var Direction;
(function (Direction) {
    Direction["left"] = "left";
    Direction["right"] = "right";
})(Direction || (Direction = {}));
export var Size;
(function (Size) {
    Size["small"] = "small";
    Size["medium"] = "medium";
    Size["large"] = "large";
})(Size || (Size = {}));
export var Version;
(function (Version) {
    Version["default"] = "default";
    Version["legacy"] = "legacy";
})(Version || (Version = {}));
export const LegacyContents = ['A+++', 'A++', 'A+', 'A', 'B'];
export const DefaultContents = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
//# sourceMappingURL=EnergyLabel.types.js.map